import { useCallback, useEffect, useRef, useState } from 'react';
import './AdminSidebar.scss';
import images from "../../assets/images/index";
import { useLocation, Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from '../../redux/app/hooks';
import { logout, setSplashvisible, setSystemMessagesCount } from '../../redux/slices/authSlice';
import ConfirmationPopup from '../ConfirmationPopup/ConfirmationPopup';
import { 
  FACILITATOR_WORKSHOP_PATH, 
  FETCH_POLICY, 
  FETCH_POLICY_NO_CACHE, 
  LOGOUT_MESSAGE_IN_MEETING_HOST, 
  LOGOUT_MESSAGE_IN_MEETING_PARTICIPANT, 
  LOGOUT_MESSAGE_NOT_IN_MEETING, 
  SCHOOL_ADMIN, 
  TEACHER_ROLE 
} from '../../utils/constants';
import { Tooltip } from '@mui/material';
import { useLazyQuery, useMutation } from '@apollo/client';
import { SYSTEM_MESSAGES_FROM_KATON, SYSTEM_MESSAGES_TOTAL_COUNT } from '../../pages/AdminSystemMessages/api/AdminSystemMessages';
import { trackButtonClick } from '../../firebase/analyticsHelper';
import { ButtonClickEvents } from '../../firebase/constants/events';
import { DELETE_SESSION_PARTICIPANT, UPDATE_SESSION_RECORD } from '../../Chime/helpers/Api/ChimeApi';
import { setCurrentSessionRecordingDetail, setIsStartingMeeting } from '../../redux/slices/dashboardSlice';
import ToasterWithMessage from '../toaster';
import { UPDATE_WORKSHOP_ENDED, UPDATE_WORKSHOP_MEETING_ID } from '../../pages/Workshop/api/WorkshopQuery';
import { UPDATE_MEETING_STATUS } from '../../pages/AdminPta/api/PtaQuery';
import { END_THE_LIVE_SESSION } from '../../pages/LiveClass/api/LiveClassQuery';
import { getIsJoinedLocalValue, getLocalParticipantId } from '../../utils/helper';
import { useKatonMeetLogoutGuard } from '../KatonMeet/useKatonMeetLogoutGuard';



const AdminSidebar = () => {
  const { DashboardIcon, HelpIcon, LogoutIcons, WorkshopIcon,
    SettingsIcons, logoutGif, NotificationIcon,SystemNotificationIcon, UploadIconDashboard,
    bookIconGrey, paymentIcon
  } = images;
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { role, selectedClassRoomId, loginpage, schoolType } = useAppSelector((state) => state.auth);
  const { currentSessionId, currentWorkshopId, currentPtaMeetId } = useAppSelector((state) => state?.dashboard);
  const selectedSubjectId = localStorage.getItem('selectedSId');
  const meetComponent = useAppSelector((state) => state?.dashboard?.meetComponent);
  const {error} = ToasterWithMessage();
  const isLogoutBlockedByKatonMeet = useKatonMeetLogoutGuard();
  const isMeetRecording = localStorage.getItem("isMeetRecording");
  const profile = useAppSelector((state) => state?.auth?.adminProfile);
  const profileImage = useAppSelector((state) => state?.auth?.adminProfileImage);
  const systemMessageCount = useAppSelector((state) => state?.auth?.systemMessagesCount)
  const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
  const [isOverflow, setIsOverflow] = useState(false);
  const schoolNameRef = useRef<HTMLDivElement | null>(null);
  const [logoutMessage, setLogoutMessage] = useState<string>('');
  // const [systemMessageCount, setSystemMessageCount] = useState<number>(0)
  const meetService = useAppSelector((state) => state.auth.meetService);
  const currentUserId = useAppSelector((state) => state?.dashboard?.currentUserId);
  console.log("loginpage", loginpage);
  

  const schoolAdminMenus = [
    { id: 'Dashboard', label: "Dashboard", icon: DashboardIcon, link: "/admin-dashboard", set: "setOne" },
    { id: 'Upload', label: "Upload", icon: UploadIconDashboard, link: "/admin-materials-upload", set: "setOne" },
    ...(schoolType === "VIRTUAL"
      ? [{ id: 'Payments', label: "Payments", icon: paymentIcon, link: "/admin-payments", set: "setOne" }]
      : []
    ),
    { id: 'Workshop', label: "Workshop", icon: WorkshopIcon, link: "/admin-workshop", set: "setOne" },
    { id: 'Notification', label: "Notification", icon: NotificationIcon, link: "/admin-notification", set: "setOne" },
    { id: 'System-messages', label: "System Messages", icon: SystemNotificationIcon, link: "/admin-system-message", set: "setOne" },
    { id: 'Settings', label: "Settings", icon: SettingsIcons, link: "/admin-settings", set: "setTwo" },
    { id: 'Help', label: "Help", icon: HelpIcon, link: "/admin-help", set: "setTwo" },
  ];

  const facilitatorMenus = [
    { id: 'Workshop', label: "Workshop", icon: WorkshopIcon, link: FACILITATOR_WORKSHOP_PATH, set: "setOne" }
  ];

  // Menu Item Set of Array
  const menuItems = [
    ...((role === SCHOOL_ADMIN && location.pathname !== FACILITATOR_WORKSHOP_PATH) ? schoolAdminMenus : facilitatorMenus),
    { id: 'Logout', label: "Logout", icon: LogoutIcons, link: "/logout", set: "setThree" },
  ];

  // To Display only the expected Menu items in the Menu's in that Set
  const getMenuItemsBySet = (set: string) => menuItems.filter((item: any) => item.set === set);

  // click logout from sidebar
  const onLogoutClick = () => {
    if (isLogoutBlockedByKatonMeet()) return;

    const isJoined = getIsJoinedLocalValue();

    if(isJoined && isJoined === "joined"){
      if(((meetComponent === 'liveclass') && ((role === TEACHER_ROLE) || (localStorage.getItem('hostId')?.includes(currentUserId)))) || 
        ((meetComponent === 'workshop') && ((role === SCHOOL_ADMIN) || (localStorage.getItem('hostId')?.includes(currentUserId)))) || 
        ((meetComponent === 'pta') && ((role === SCHOOL_ADMIN) || (localStorage.getItem('hostId')?.includes(currentUserId))))) {
        setLogoutMessage(LOGOUT_MESSAGE_IN_MEETING_HOST);  
      } else {
        setLogoutMessage(LOGOUT_MESSAGE_IN_MEETING_PARTICIPANT);
      }
    } else {
      setLogoutMessage(LOGOUT_MESSAGE_NOT_IN_MEETING);
    }
    setOpenConfirmationPopup(true);
  }

  const [deleteSessionParticipant] = useMutation(DELETE_SESSION_PARTICIPANT, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      console.log("Participant deleted successfully:", data);
    },
    onError: (err) => {
      console.log(err)
    },
  });

    // API's for updating the live class record start timer and recording status
    const [updateSessionRecord] = useMutation(UPDATE_SESSION_RECORD, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            error(err?.message);
        }
    });  

    // API to update Workshop staring status, recording status and recording timer
    const [updateWorkshopSession] = useMutation(UPDATE_WORKSHOP_MEETING_ID, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            error(err?.message);
        }
    });  
    
    // API to update PTA meeting status, recording timer and recording status
    const [updatePtaMeeting] = useMutation(UPDATE_MEETING_STATUS, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            error(err?.message);
        }
    }); 
    
    // API's for updating the live class end status
    const [updateSessionEnd] = useMutation(END_THE_LIVE_SESSION, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            error(err?.message);
        }
    });    

    // API to update Workshop end status
    const [updateWorkshopEnd] = useMutation(UPDATE_WORKSHOP_ENDED, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            error(err?.message);
        }
    });    

  const handleDeleteParticipant = useCallback(async () => {
    console.log("[logout] all values", meetComponent, currentSessionId, selectedSubjectId, selectedClassRoomId, getLocalParticipantId(meetService || ''));
      if (
        meetComponent === "liveclass" &&
        currentSessionId &&
        selectedSubjectId &&
        selectedClassRoomId
      ) {
        deleteSessionParticipant({
          variables: {
            cId: selectedClassRoomId,
            sId: currentSessionId,
            sjId: selectedSubjectId,
            participantId: getLocalParticipantId(meetService || ''),
          },
        });
      }
  }, [meetComponent, selectedSubjectId, currentSessionId, selectedClassRoomId, meetService, deleteSessionParticipant]);

    const handleUpdateRecordTime = useCallback(async (recordingStatus: boolean, recordStartTime: string) => {
        if (meetComponent === "liveclass" && selectedClassRoomId && currentSessionId && selectedSubjectId) {
            await updateSessionRecord({
                variables: {
                    cId: selectedClassRoomId,
                    sId: currentSessionId,
                    sjId: selectedSubjectId,
                    isRecordStart: recordingStatus,
                    recordStarttime: recordStartTime,
                },
            });
        } else if (meetComponent === "workshop" && currentWorkshopId) {
            await updateWorkshopSession({
                variables: {
                    updateInput: {
                        isRecordStart: recordingStatus,
                        recordStartTime,
                    },
                    wsId: currentWorkshopId,
                }
            });
        } else if (meetComponent === "pta" && currentPtaMeetId) {
            await updatePtaMeeting({
                variables: {
                    updateInput: {
                        isRecordStart: recordingStatus,
                        recordStartTime,
                    },
                    mId: currentPtaMeetId,
                }
            });
        }
        localStorage.setItem("isMeetRecording", recordingStatus ? "true" : "false");
        dispatch(setCurrentSessionRecordingDetail({ recordingStartedTime: recordStartTime, recordingStarted: recordingStatus }));
    }, [ 
      meetComponent, 
      currentSessionId, 
      selectedClassRoomId, 
      selectedSubjectId, 
      currentWorkshopId, 
      currentPtaMeetId, 
      updateSessionRecord, 
      updateWorkshopSession, 
      updatePtaMeeting, 
      dispatch
    ]);  

    const updateEndMeeting = useCallback(async () => {
        console.log("[Log] updateEndMeeting called");
        if (meetComponent === "liveclass" && 
            ((role === TEACHER_ROLE) || (localStorage.getItem('hostId')?.includes(currentUserId))) && 
            selectedSubjectId && 
            currentSessionId && 
            selectedClassRoomId) {
            await updateSessionEnd({
                variables: {
                cId: selectedClassRoomId,
                sId: currentSessionId,
                sjId: selectedSubjectId,
                },
            });
        } 
        else if (meetComponent === "workshop" && ((role === SCHOOL_ADMIN) || (localStorage.getItem('hostId')?.includes(currentUserId))) && currentWorkshopId) {
            await updateWorkshopEnd({
                variables: {
                wsId: currentWorkshopId,
                },
            });
        } 
        else if (meetComponent === "pta" && ((role === SCHOOL_ADMIN) || (localStorage.getItem('hostId')?.includes(currentUserId))) && currentPtaMeetId) {
            await updatePtaMeeting({
                variables: {
                updateInput: {
                    mStatus: "ENDED",
                },
                mId: currentPtaMeetId,
                },
            });
        } 
    }, [meetComponent, currentSessionId, role, selectedSubjectId, selectedClassRoomId, currentWorkshopId, currentPtaMeetId, updateSessionEnd, updateWorkshopEnd, updatePtaMeeting]);

  // click yes button in confirmation popup
  const onYesButtonClick = async () => {
    const isJoined = getIsJoinedLocalValue();
    setOpenConfirmationPopup(false);
    dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
    if(getLocalParticipantId(meetService || '') && getLocalParticipantId(meetService || '') !== "") {
      await handleDeleteParticipant();
    }
    if(isMeetRecording === "true") {
      await handleUpdateRecordTime(false, new Date().toISOString());
    }

    if(isJoined === 'joined') {
      await updateEndMeeting();
    }

    trackButtonClick(ButtonClickEvents?.LOGOUT_BUTTON_CLICK, {
      description : "User clicks the logout button",
    })
    dispatch(logout());
    dispatch(setSplashvisible());
  }

  // click no button in confirmation popup
  const onNoButtonClick = () => {
    setOpenConfirmationPopup(false);
  }

  //To check the container is overflow
  const checkOverflow = () => {
    if (schoolNameRef.current) {
      setIsOverflow(schoolNameRef.current.scrollWidth > schoolNameRef.current.clientWidth);
    }
  }

  //To check overflow in resize 
  useEffect(() => {
    window.addEventListener('resize', checkOverflow);

    return () => {
      window.removeEventListener('resize', checkOverflow);
    };
  }, []);

  useEffect(() => {
    checkOverflow();
  }, [profile])

  const [systemMessagesTotalCount] = useLazyQuery(SYSTEM_MESSAGES_TOTAL_COUNT, {
    fetchPolicy : FETCH_POLICY,
    onCompleted : (data) => {
      dispatch(setSystemMessagesCount(data.allSystemMessages.totalCount))
    }
  })

  const [systemMessagesFromKaton] = useLazyQuery(SYSTEM_MESSAGES_FROM_KATON,{
    fetchPolicy : FETCH_POLICY,
    onCompleted: (data) =>{
      systemMessagesTotalCount()
    }
  })

  useEffect(()=>{
    if (role === SCHOOL_ADMIN && location.pathname !== FACILITATOR_WORKSHOP_PATH ) {
      systemMessagesFromKaton();
    }
  },[location.pathname])

  return (
    <div className='adminSidebarMainContainer'>
      <div className='adminSidebarMainBox'>
        <div className="adminSidebarProfile" style={{ flex: role === SCHOOL_ADMIN ? '' : 'unset' }}>
          <div className="adminSidebarProfileImage">
            {(profileImage) && (<img
              className="adminSidebarProfileTag"
              alt="ProfileImage"
              src={profileImage}
            />)}
          </div>
          <div className={(role === SCHOOL_ADMIN && location.pathname !== FACILITATOR_WORKSHOP_PATH) ? '' : 'teacherTabContainer'}>
            <Tooltip
              title={
                `${profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName 
                  ? profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName 
                  : "Katon Virtual School"}`
              }
              disableHoverListener={!isOverflow}
              placement="top">
              <div
                className="adminSidebarProfileText"
                ref={schoolNameRef}
                onMouseEnter={checkOverflow}
              >
                {
                `${profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName 
                  ? profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName 
                  : "Katon Virtual School"}`
                }
              </div>
            </Tooltip>
            <div className={(role === SCHOOL_ADMIN && location.pathname !== FACILITATOR_WORKSHOP_PATH) ? 'hide' : 'teacherTab'}>
              Facilitator
            </div>
          </div>
        </div>
        <div className={`${(role === SCHOOL_ADMIN && location.pathname !== FACILITATOR_WORKSHOP_PATH) ? "adminSidebarCards" : 'visiblityHide'} `}>
          <Link to={"/admin-school"} className={`adminSidebarSchoolCard ${location.pathname === "/admin-school" ? "adminSidebarSelectedCard" : ""}`}>
            <label htmlFor="customize-school" className="adminSidebarSchoolLabel">Customize</label>
            <span className="adminSidebarSchoolText">School</span>
          </Link>
          <Link to={"/admin-calendar"} className={`adminSidebarCalendarCard ${location.pathname === "/admin-calendar" ? "adminSidebarSelectedCard" : ""}`}>
            <label htmlFor="edit-calendar" className="adminSidebarCalendarLabel">Edit</label>
            <span className="adminSidebarCalendarText">Calendar</span>
          </Link>
        </div>
        <div className="adminSidebarMenuContainer" style={{ paddingBottom: role === SCHOOL_ADMIN ? '' : '30px', flex: role === SCHOOL_ADMIN ? '' : 'unset' }}>
          <div className={`${role === SCHOOL_ADMIN ? "adminSidebarMenuSet" : 'hide'} `}>
            {/* First Set */}
            {getMenuItemsBySet("setOne").map((item: any) => (
              <Link className={`menu${item?.id} ${location.pathname === item?.link ? "selectedMenu" : ""}`} key={item.id} to={item.link}>
                <img
                  className="icDashboardIcon"
                  alt="sidebarIcons"
                  src={item.icon}
                />
                <label htmlFor={item.id} className="menuDashboardLabel">{item.label}</label>
               {(item.id === 'System-messages'  && systemMessageCount > 0) && <div className='notificationBadge'>{systemMessageCount}</div>}
              </Link>
            ))}
          </div>
          <div className={`${role === SCHOOL_ADMIN ? "adminSidebarMenuSet" : 'hide'} `}>
            {/* Second Set */}
            {getMenuItemsBySet("setTwo").map((item: any) => (
              <Link 
                className={`menu${item?.id} ${`/${location.pathname.split('/')[1]}` === `${item?.link}` ? "selectedMenu" : ""}`} 
                key={item.id} 
                to={item.link}
              >
                <img
                  className="icDashboardIcon"
                  alt="sidebarIcons"
                  src={item.icon}
                />
                <label htmlFor={item.id} className="menuDashboardLabel">{item.label}</label>             
              </Link>
            ))}
          </div>
          <div className="adminSidebarMenuSet">
            {/* Third Set */}
            {getMenuItemsBySet("setThree").map((item: any) => (
              <div onClick={onLogoutClick} className={`menu${item?.id}`} key={item.id}>
                <img
                  className="icDashboardIcon"
                  alt="sidebarIcons"
                  src={item.icon}
                />
                <label htmlFor={item.id} className="menuDashboardLabel">{item.label}</label>
              </div>
            ))}
          </div>
        </div>
      </div>
      <ConfirmationPopup
        open={openConfirmationPopup}
        message={logoutMessage}
        gifData={logoutGif}
        yesButtonFunctionality={onYesButtonClick}
        noButtonFunctionality={onNoButtonClick}
        messageWidth={'345px'}
        popupContainerHeight = {(getIsJoinedLocalValue() === 'joined') ? '230px' : '202px'}
      />
    </div>
  );
}

export default AdminSidebar;
